<script>
export default {
  name: "FieldCheckbox",
  inject: [ 'store'],
  emits: ["onEvaluateValueResetter"],
  props: ["field"],
  methods:{
    evaluateValueResetterForSelect(field){
      this.$emit("onEvaluateValueResetter", field)
    }
  }
}
</script>


<template>
<div class="checkbox-wrapper">
  <input 
    type="checkbox" 
    :checked="store.calcModel[field.id]"
    :id="field.id" 
    :name="field.id" 
    :use-keyboard="true" 
    v-model="store.calcModel[field.id]" 
    @change="evaluateValueResetterForSelect(field)"
  />
</div>
</template>